export const types = {
    EMIT_ERROR:          'EMIT_ERROR',
    START_EDIT_TASK:     'START_EDIT_TASK',
    STOP_EDIT_TASK:      'STOP_EDIT_TASK',
    UPDATE_TASK_MESSAGE: 'UPDATE_TASK_MESSAGE',
    START_SPINNING:      'START_SPINNING',
    STOP_SPINNING:       'STOP_SPINNING',
};
